(function () {
  if (window.__bmProductFamilyDesktopDragInit) return;
  window.__bmProductFamilyDesktopDragInit = true;

  function initTrack(track) {
    var isDown = false;
    var dragging = false;
    var startX = 0;
    var startScrollLeft = 0;
    var moved = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      if (e.button !== 0) return;

      isDown = true;
      dragging = false;
      moved = 0;
      startX = e.clientX;
      startScrollLeft = track.scrollLeft;
    });

    track.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      var adx = Math.abs(dx);

      // Only enter drag mode after a small threshold, so clicks still work.
      if (!dragging && adx > 3) {
        dragging = true;
        track.classList.add('is-dragging');
      }

      if (!dragging) return;

      moved = Math.max(moved, adx);
      track.scrollLeft = startScrollLeft - dx;
    });

    function endDrag() {
      if (!isDown) return;
      isDown = false;
      dragging = false;
      track.classList.remove('is-dragging');
    }

    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);

    // Prevent click navigation if user dragged
    track.addEventListener(
      'click',
      function (e) {
        if (moved > 6) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );

    // Convert vertical wheel to horizontal scroll while hovering
    track.addEventListener(
      'wheel',
      function (e) {
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
        track.scrollLeft += e.deltaY;
        e.preventDefault();
      },
      { passive: false }
    );
  }

  function initAll() {
    document
      .querySelectorAll('.product-family .js-cart-drawer-upsell-track[data-drag-init="true"]')
      .forEach(initTrack);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();